export default __webpack_public_path__ + "static/media/Scroll.ca1e50d4.jpg";